import { useSEO } from "../hooks/useSEO";
import { PolicyShell, H, BusinessDetails } from "./_policyShell";

const Terms = () => {
  useSEO({
    title: "Terms & Conditions",
    description: "Sterling Bio Ltd terms and conditions of sale for UK research peptide customers. Company No. 17209385. Governed by the laws of England and Wales.",
    path: "/terms",
  });
  return (
    <PolicyShell kicker="Legal" title="Terms & Conditions" testid="terms-page">
      <p className="text-sm text-[#64748B] font-mono uppercase tracking-wider">
        Last updated: 25 February 2026
      </p>
      <p>
        These Terms &amp; Conditions govern your use of this website and the purchase of products
        from <strong>Sterling Bio Ltd</strong>, a private limited company registered in England
        &amp; Wales (Company No. 17209385). By placing an order you confirm you have read,
        understood and accepted these terms.
      </p>

      <BusinessDetails />

      <H>1. Eligibility &amp; research use</H>
      <p>
        All products supplied by Sterling Bio are intended exclusively for{" "}
        <strong>in-vitro laboratory research</strong>. They are not classified as medicines, food
        supplements or cosmetics. By purchasing, you confirm that you are at least 18 years of
        age, a qualified researcher or affiliated with a research institution, and that you will
        not administer products to humans or animals.
      </p>

      <H>2. Orders &amp; pricing</H>
      <p>
        Orders are confirmed once payment has been received. Prices are listed in <strong>GBP
        (£)</strong> and are the total amount payable for the product. Sterling Bio is{" "}
        <strong>not currently VAT-registered</strong> — no separate VAT is added at checkout.
        Stock availability is updated in real time, but Sterling Bio reserves the right to cancel
        an order in the event of a stock or pricing error and refund the customer in full.
      </p>

      <H>3. Payment</H>
      <p>
        Payment is by <strong>UK bank transfer via Pay-by-Bank</strong> (Open Banking). At
        checkout you are redirected to your bank&apos;s app to approve the transfer — no card
        details are entered on this site, and no card data is stored by Sterling Bio. Payments
        are processed by Wallid (pay-by-bank.wallid.co) under UK Open Banking regulation.
      </p>

      <H>4. Shipping &amp; delivery</H>
      <p>
        Free UK tracked shipping is included with every order. Orders confirmed before{" "}
        <strong>14:00 GMT</strong> on a UK business day are dispatched same-day. Expected
        delivery is <strong>1–2 business days</strong> via Royal Mail Tracked. International
        shipping is not currently offered. Full details, including dispatch hold periods for
        unpaid orders, are on the{" "}
        <a className="text-[#2C8C9C] hover:underline" href="/shipping">Shipping &amp; Delivery</a>{" "}
        page.
      </p>

      <H>5. Right to cancel &amp; returns</H>
      <p>
        Under the UK Consumer Contracts Regulations 2013 you have <strong>14 days</strong> from
        receipt of goods to cancel a purchase made online. See our{" "}
        <a className="text-[#2C8C9C] hover:underline" href="/refund-policy">
          Refund &amp; Cancellation Policy
        </a>{" "}
        for the full procedure, return address and card-scheme refund windows.
      </p>

      <H>6. Limitation of liability</H>
      <p>
        To the maximum extent permitted by law, Sterling Bio Ltd shall not be liable for any
        indirect, incidental or consequential damages arising from the use or misuse of any
        product supplied. Our total liability for any single order shall not exceed the value of
        that order.
      </p>

      <H>7. Complaints</H>
      <p>
        We aim to resolve every complaint within 5 UK business days. The full procedure, contact
        details and escalation route are on the{" "}
        <a className="text-[#2C8C9C] hover:underline" href="/complaints">Complaints</a> page.
      </p>

      <H>8. Governing law</H>
      <p>
        These terms are governed by the laws of England and Wales. Any disputes shall be subject
        to the exclusive jurisdiction of the English courts.
      </p>
    </PolicyShell>
  );
};

export default Terms;
